import { createContext, useContext, useEffect, useState } from "react";
import api, { isStandalone } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=loading, false=anonym, object=user
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                if (mounted) setUser(data);
            } catch (e) {
                if (mounted) setUser(false);
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        const expired = () => { if (mounted) setUser(false); };
        window.addEventListener("auth:expired", expired);
        return () => { mounted = false; window.removeEventListener("auth:expired", expired); };
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password, pwa: isStandalone() });
        setUser(data);
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        setUser(data);
        return data;
    };

    const logout = async () => {
        // 1) odeslat frontu neodeslaných záznamů; offline → uživatel rozhodne
        const { getQueue, flushQueue } = await import("../lib/offline");
        if (getQueue().length > 0) {
            if (navigator.onLine) await flushQueue().catch(() => {});
            const left = getQueue().length;
            if (left > 0 && !window.confirm(`Máte ${left} neodeslané záznamy (deník, hodiny, jízdy…) – odhlášením se ztratí. Opravdu se odhlásit?`)) return false;
        }
        try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
        // 2) smazat lokální data: offline frontu, rozpracované koncepty, cache service workeru
        try {
            ["token", "ceramixa_offline_queue", "trip_draft", "gps_trip_active"].forEach((k) => localStorage.removeItem(k));
            if ("caches" in window) { const keys = await caches.keys(); await Promise.all(keys.filter((k) => k.includes("api")).map((k) => caches.delete(k))); }
        } catch (e) { /* ignore */ }
        setUser(false);
        return true;
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, register, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
